/** English strings. The source of truth: other languages must have the same keys. */
export const en = {
  'app.tagline': "A digital seal on a container's condition at every handover",
  'app.language': 'Język: polski',
  'nav.label': 'Main',
  'nav.handovers': 'Handovers',
  'nav.fleet': 'Containers',
  'nav.inspect': 'Inspect',
  'app.openSource': 'Plomba is open source (Apache-2.0):',

  'common.retry': 'Try again',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.back': 'Back',
  'common.loading': 'Loading…',
  'common.error': 'Something went wrong',
  'common.offline': 'No connection. Your work is safe; try again when you are back online.',

  'intro.identify': 'Point the phone at the doors: the container number is read and verified.',
  'intro.record': 'Photograph each face, or record one walk around the container.',
  'intro.confirm':
    "Damage from the last handover appears on the same spot. Confirm it, and record what's new.",
  'intro.seal':
    'Seal the handover: a receipt, a gate message and a tamper-evident history that follows the container.',
  'profile.change': 'Change',
  'common.done': 'Done',
  'intro.eyebrow': 'How Plomba works',
  'home.greeting': 'Checker',
  'home.statOpen': 'Open',
  'home.statSealedToday': 'Sealed today',
  'home.statMarks': 'Marks open',
  'home.heroTitle': 'Inspect a container',
  'home.heroText':
    'Read the doors, photograph or record the walk-around, confirm what changed since the last handover, and seal the record.',
  'fleet.eyebrow': 'Fleet',
  'fleet.title': 'Containers',
  'fleet.intro': 'Every container this installation has recorded, most recently handed over first.',
  'fleet.search': 'Owner code or number',
  'fleet.none': 'No containers yet. Inspect one to start its history.',
  'fleet.noMatch': 'No container matches.',
  'fleet.handovers': 'handovers: {count} · sealed: {sealed}',
  'profile.title': 'Checker',
  'profile.name': 'Your name',
  'profile.place': 'Place (terminal or depot)',
  'profile.missing': 'Enter your name and place to start.',

  'home.inspect': 'Inspect a container',
  'home.open': 'Open handovers',
  'home.recent': 'Recently sealed',
  'home.none': 'No handovers yet.',
  'home.install': 'Install app',
  'home.installIos': 'To install: tap Share, then “Add to Home Screen”.',
  'home.photos': 'photos: {count}',
  'home.marks': 'marks: {count}',

  'camera.take': 'Take photo',
  'camera.choose': 'Choose a photo',
  'camera.denied': 'The camera is not available. You can choose a photo instead.',
  'camera.starting': 'Starting camera…',

  'identify.title': 'Identify the container',
  'identify.guide':
    'Frame the door markings: the container number and the size/type code below it.',
  'identify.reading': 'Reading markings with Muse Spark…',
  'identify.checking': 'Checking the ISO 6346 check digit',
  'identify.verified': 'Check digit verified',
  'identify.suggested': 'Check the suggested number',
  'identify.readAs': 'Read as {read}',
  'identify.tapToChoose': 'Tap the number painted on the container, or type it below.',
  'identify.ambiguous': 'Choose the number painted on the container',
  'identify.unreadable': 'Could not read a valid number',
  'identify.number': 'Container number',
  'identify.numberValid': 'Valid ISO 6346 number',
  'identify.numberExpected': 'Check digit should be {digit}',
  'identify.numberIncomplete': 'Owner code, U/J/Z, six digits and the check digit',
  'identify.sizeType': 'Size and type code',
  'identify.sizeTypeUnknown': 'Unknown: a 40 ft container is assumed',
  'identify.seals': 'Seals',
  'identify.hazards': 'Hazard placards',
  'identify.confirm': 'Confirm container',
  'identify.retake': 'Retake photo',
  'identify.manual': 'Type the number instead',
  'identify.highlight': 'Highlighted characters differ from what was read.',

  'container.dimensions': '{length} × {width} × {height} m',
  'container.chainOk': 'History intact · sealed handovers: {count}',
  'container.chainEmpty': 'No sealed handovers yet',
  'container.chainBroken': 'History altered at handover #{index}',
  'container.continue': 'Continue the open handover',
  'container.start': 'Start a handover',
  'container.eyebrow': 'Container',
  'container.history': 'Handover history',

  'start.direction': 'Direction',
  'start.in': 'Gate in',
  'start.out': 'Gate out',
  'start.place': 'Place',
  'start.checker': 'Checker',
  'start.handedOverBy': 'Handed over by (carrier, driver)',
  'start.receivedBy': 'Received by',
  'start.seals': 'Seal numbers, comma-separated',
  'start.submit': 'Start handover',

  'handover.in': 'Gate in',
  'handover.out': 'Gate out',
  'handover.open': 'Open',
  'handover.closed': 'Sealed',
  'handover.faces': 'Faces: {done} of {total}',
  'handover.coverage': 'Sections with a photo: {done} of {total}',
  'handover.sealWithGaps':
    'Not photographed: {gaps}. Seal anyway? The record will say these sections were not inspected.',
  'handover.sections': '{count} sections',
  'handover.previous': 'From the last handover',
  'handover.previousNone': 'No earlier handover of this container.',
  'handover.previousPending': 'to confirm: {count}',
  'handover.photograph': 'Stand square to the {face} so it fills the frame.',
  'handover.uploading': 'Blurring faces and plates, finding the container…',
  'handover.retake': 'New photo',
  'handover.adjust': 'Adjust corners',
  'handover.adjustHint': 'Drag the four corners onto the corners of the {face}.',
  'handover.cornersMissing': 'The container outline was not found. Drag the corners into place.',
  'handover.addMark': 'Mark damage',
  'handover.addMarkHint': 'Drag a box around the damage.',
  'handover.speakDamage': 'Say the damage',
  'handover.speaking': 'Muse Voice is listening; Muse Spark is coding the damage…',
  'handover.spokenNone':
    'No damage with a place on the container was heard. Say, for example: “dent, left side, section 3, lower half”.',
  'handover.unplaced': 'Say where (face and section) for: {items}',
  'handover.findDamage': 'Find damage',
  'handover.finding': 'Muse Spark is looking for damage; SAM 3.1 is outlining it…',
  'handover.found': 'Proposed: {count}. Confirm or reject each one below.',
  'handover.noneFound': 'No new damage found on this photo.',
  'handover.reviewFirst': 'Confirm or reject the proposed damage before sealing.',
  'handover.marks': 'Marks in this handover',
  'handover.noMarks': 'No damage marked.',
  'handover.seal': 'Seal handover',
  'handover.sealConfirm': 'Seal this handover? It can no longer be changed afterwards.',
  'handover.sealed': 'Sealed into the container history',
  'handover.hash': 'Record hash',
  'handover.redacted': 'Blurred for privacy: {count}',

  'mark.damage': 'Damage',
  'mark.component': 'Component',
  'mark.note': 'Note',
  'mark.save': 'Save mark',
  'mark.stillThere': 'Still there',
  'mark.changed': 'Changed',
  'mark.repaired': 'Repaired',
  'mark.reject': 'Remove',
  'mark.confirm': 'Confirm',
  'mark.proposed': 'Proposed by the models',
  'mark.status.new': 'New',
  'mark.status.still-there': 'Still there',
  'mark.status.changed': 'Changed',
  'mark.status.repaired': 'Repaired',
  'mark.resolved': 'Confirmed',

  'report.title': 'Equipment interchange receipt (EIR)',
  'report.print': 'Print or save as PDF',
  'report.open': 'Open the EIR',
  'report.started': 'Inspection started',
  'report.sealedAt': 'Sealed',
  'report.seal': 'Seal',
  'report.chainPosition': 'Handover #{position} in the container history',
  'report.chainOk': 'history verified intact',
  'report.previousHash': 'Previous record hash',
  'report.notSealed': 'Not sealed yet: this is a draft.',
  'report.comparison': 'Comparison with the previous handover',
  'report.then': 'Previous handover',
  'report.now': 'This handover',
  'report.recorded': 'Recorded',
  'report.notChecked': 'Not checked',
  'report.newDamage': 'New since the previous handover',
  'report.damage': 'Damage (ISO 9897 / CEDEX)',
  'report.location': 'Location',
  'report.status': 'Status',
  'report.firstRecorded': 'First recorded',
  'report.here': 'At this handover',
  'report.photos': 'Photos',
  'report.codeco': 'EDIFACT CODECO gate report',
  'report.codecoHint':
    "The gate-in or gate-out message for the shipping line or terminal system, with the damage and this record's hash.",
  'report.recipient': "Recipient ID (e.g. the shipping line's EDI code)",
  'report.downloadCodeco': 'Download CODECO',

  'dictate.start': 'Dictate a note',
  'dictate.stop': 'Stop recording',
  'dictate.working': 'Muse Voice is transcribing…',
  'dictate.denied': 'The microphone is not available.',
  'claim.title': 'Damage claim',
  'claim.draft': 'Draft a claim with Muse Spark',
  'claim.drafting': 'Muse Spark is reading the records and drafting the claim…',
  'claim.verified': 'Checked against the sealed records',
  'claim.attempts': 'Drafts written until every check passed: {count}. Tools used: {tools}.',
  'claim.to': 'To',
  'claim.subject': 'Subject',
  'claim.copy': 'Copy the letter',
  'claim.copied': 'Copied',
  'claim.check.items-are-new-damage':
    'Every item is damage recorded as new in this sealed handover',
  'claim.check.codes-and-photos-match':
    'Locations, damage codes and photo SHA-256 hashes match the records',
  'claim.check.letter-cites-records':
    'The letter cites the container number and both sealed record hashes',
  'access.title': 'Enter the access code',
  'access.hint':
    'Your organisation set a code for this Plomba installation. You enter it once on this device.',
  'access.code': 'Access code',
  'access.submit': 'Continue',
  'live.searching': 'Looking for the container…',
  'live.ghosts': "Live: the last handover's damage",
  'identify.why.verified': 'The check digit matches what was read.',
  'identify.why.oneRepair':
    '“{read}” fails the check digit. Changing {changes} would make it valid: check those characters on the container.',
  'identify.why.modelChose':
    '“{read}” fails the check digit, and {count} numbers close to it are valid. Muse Spark suggests the first after comparing them with the photo.',
  'identify.why.ambiguous':
    '“{read}” fails the check digit, and {count} numbers close to it are equally likely.',
  'identify.why.noRepair':
    '“{read}” fails the check digit and isn’t one or two look-alike characters away from a valid number.',
  'identify.why.nothing': 'No container number is visible. Photograph the doors straight on.',
  'identify.change': '{from} → {to} (character {position})',
  'identify.modelNote': 'Muse Spark',
  'error.validation': 'The request was not accepted',
  'error.unauthorized': 'Access refused',
  'error.not-found': 'Not found',
  'error.conflict': 'This can’t be done now',
  'error.upstream': 'A model didn’t answer properly. Try again.',
  'start.transport': 'Arrived or leaves by',
  'start.road': 'Truck',
  'start.rail': 'Rail wagon',
  'start.truck': 'Truck registration',
  'start.wagon': 'Wagon number (UIC, 12 digits)',
  'start.wagonValid': 'valid UIC number',
  'start.wagonDigits': '12 digits, the last one a check digit',
  'start.wagonExpected': 'The check digit should be {digit}',
  'handover.road': 'Truck {vehicle}',
  'handover.rail': 'Wagon {vehicle}',
  'passport.title': 'Damage passport',
  'passport.intro':
    'Every damage recorded on this container, from the sealed handovers only. Colour shows the handover that first recorded it.',
  'passport.mapLabel': "Map of the container's faces with the recorded damage",
  'passport.handover': '#{n} {direction} · {place} · {date}',
  'passport.none': 'No damage recorded at any sealed handover.',
  'passport.firstRecorded': 'First recorded: {handover}',
  'passport.lastClear': 'Not there at: {handover}.',
  'passport.between': 'It happened between these two handovers.',
  'passport.alreadyThere': 'Already there at the first sealed handover.',
  'passport.notInspected': 'Spot not photographed at: {handovers}',
  'passport.recordedNearby':
    'Damage was already recorded on this spot at: {handover}. It may be the same damage.',
  'passport.broken': "The container's history doesn't verify, so no damage history is shown.",
  'walk.title': 'Walk-around video',
  'walk.intro':
    "One clip from a phone or Meta AI glasses becomes this handover's photos. The clip itself is not stored.",
  'walk.tip':
    'Stop for a second square-on to each face, far enough back for the whole face to fit in the frame.',
  'walk.samples': 'Or try a sample clip',
  'walk.loadingSample': 'Loading the sample clip…',
  'walk.sampleCredit': 'Sample clip:',
  'walk.blankFrames':
    "This browser returned blank frames from the clip, so the faces can't be named. Try again, or use another browser.",
  'walk.sideGuessed':
    "Left or right is a guess: the doors aren't in view. Check which end they are at.",
  'walk.how.track': 'SAM 3.1 tracks the container through every frame',
  'walk.how.pick': 'Plomba picks the frames where a face is whole, and splits corners',
  'walk.how.name': 'Muse Spark names each face and reads the doors',
  'walk.how.confirm': 'You confirm; the frames become photos',
  'walk.video': 'Choose a video (MP4 or MOV)',
  'walk.analyse': 'Analyse the walk-around',
  'walk.step.tracking': 'SAM 3.1 is tracking the container through every frame…',
  'walk.step.choosing': 'Choosing the frames where one face is whole and square-on…',
  'walk.step.naming': 'Muse Spark is naming the face in each frame…',
  'walk.step.reading': 'Muse Spark is reading the doors…',
  'walk.summary':
    'Container found in frames: {tracked} of {total} · frames chosen: {candidates} · faces seen: {faces}',
  'walk.cached': 'tracking from the cache',
  'walk.noFrames':
    'No frame shows a whole face of the container. Record again from further back, so that each face fits in the frame.',
  'walk.doorsMatch': 'The doors in the video match this handover:',
  'walk.doorsMismatch': 'The doors in the video show another container:',
  'walk.doorsUnverified':
    "The number on the doors couldn't be verified from the video. Check it on the doors.",
  'walk.frames': 'Frames chosen from the clip',
  'walk.frameAlt': 'Frame {frame} of the clip',
  'walk.noFace': 'No single face',
  'walk.angled': 'at an angle',
  'walk.unclear': 'blurred or covered',
  'walk.useAs.whole': 'Use as the photo of',
  'walk.useAs.left': 'Left of the corner as',
  'walk.useAs.right': 'Right of the corner as',
  'walk.notUsed': 'Not used',
  'walk.findDamage': 'Look for damage on each photo (Muse Spark and SAM 3.1)',
  'walk.add': 'Add to the handover (photos: {count})',
  'walk.adding': 'Adding photo {n} of {total}: {face}…',
  'walk.lookingForDamage': 'Looking for damage: {face}…',
  'walk.frame': 'SAM 3.1 · frame {frame} of {total}',
  'walk.lost': 'Container not found in this frame',
  'walk.label': 'Recorded video, not a live camera',
  'handover.history': 'Container history',
  'handover.walkaround': 'Walk-around video',
  'face.D': 'door end',
  'face.R': 'right side',
  'face.F': 'front end',
  'face.L': 'left side',
  'face.T': 'roof',
  'faceTitle.D': 'Doors',
  'faceTitle.R': 'Right',
  'faceTitle.F': 'Front',
  'faceTitle.L': 'Left',
  'faceTitle.T': 'Roof',
};

export type MessageKey = keyof typeof en;
export type Messages = Record<MessageKey, string>;
